/**
 * Asynchronously loads the component for AdminStudents
 */

import { lazyLoad } from "utils/loadable";

export const AdminStudents = lazyLoad(
  () => import("./index"),
  (module) => module.AdminStudents
);
